export default {
  steps: {
    discount: 'Rabatt',
    mobile_app: 'Mobile App',
    business_info: 'Geschäftsdaten',
    create_preview: 'Vorschauvertrag erstellen',
    preview: 'Vertragsvorschau',
    sign: 'Vertrag unterzeichnen',
  },
  buttons: {
    back: 'Zurück',
    continue: 'Weiter',
  },
  agreement:
    'Mit der Umstellung auf jährlich wird der {{discount}}% Rabatt auf Ihren {{plan}}-Tarif angewendet. Die Abrechnung erfolgt weiterhin monatlich mit {{amount}} pro Monat bei einer Laufzeit von {{months}} Monaten.',
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    failed_to_switch: 'Umstellung auf Jahresvertrag fehlgeschlagen',
    switched_to_annual: 'Vertrag auf Jahresvertrag umgestellt 👌',
  },
};
